import { atom } from 'jotai';

export const DEFAULT_SELECTED_WEEK = 0;

interface canvasDataInterface {
    notes: string;
    description: string;
    type: string;
    groupID: string;
    canvasID: string
    categories: Array<{ entries: [] }>;
    linkSet: [];
    id: string;
    created: string;
    modified: string;
    name: string;
    states: {};
    selectedWeek:number;
}

export const INITIAL_CANVAS_DATA_ATOM_VALUE: canvasDataInterface = {
    notes: '',
    description: '',
    type: '',
    groupID: '',
    categories: [{entries: []}],
    linkSet: [],
    id: '',
    created: '',
    modified: '',
    name: '',
    states: {},
    selectedWeek: DEFAULT_SELECTED_WEEK,
    canvasID: '',
};

export const canvasDataAtom = atom(INITIAL_CANVAS_DATA_ATOM_VALUE);

export const updatedCanvasData = (setCanvasData: Function, value: canvasDataInterface) => {
    const buffer={
        ...value,
    }
    buffer.selectedWeek=DEFAULT_SELECTED_WEEK,
    setCanvasData(buffer);
};